import type { SVGProps } from 'react';

const Stop = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5 3.83331H4.5C4.13181 3.83331 3.83333 4.13179 3.83333 4.49998V11.5C3.83333 11.8682 4.13181 12.1666 4.5 12.1666H11.5C11.8682 12.1666 12.1667 11.8682 12.1667 11.5V4.49998C12.1667 4.13179 11.8682 3.83331 11.5 3.83331Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Stop;
